var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center",staticStyle:{"height":"82vh !important"}},[_c('img',{staticStyle:{"max-width":"15%","height":"auto"},attrs:{"src":_vm.loaderLogo,"alt":"Academy Si2p Logo"}}),_c('div',{staticClass:"spinner-primary spinner-border",staticStyle:{"width":"3rem","height":"3rem"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }